export default {
  hello: 'hello',
  i18n_home: 'Home',
  i18n_Tracking: 'Tracking',
  i18n_Check_Pricing_and_order: 'Placing Order',
  i18n_Return: 'Return',
  i18n_Order_info: 'Order info',
  i18n_Tracking_number: 'Tracking number',
  i18n_destination: 'destination',
  i18n_Original_Port: 'Original Port',
  i18n_arrived_warehouse_date: 'arrived warehouse date',
  i18n_Shipping_method: 'Shipping method',
  i18n_Package_info: 'Package info',
  i18n_Please_ship_your_package_to_below_warehouse: 'Please ship your package to below warehouse',
  i18n_Forecast_pakcage_info: 'Forecast pakcage info',
  i18n_Accurated_package_info: 'Accurated package info',
  i18n_Serial_number: 'Serial number',
  i18n_FBA_number: 'FBA number',
  i18n_Cititrans_Tracking_number: 'Cititrans Tracking number',
  i18n_box_counting_number: 'box counting number',
  i18n_Amazon_Reference_Number_PO: 'Amazon Reference Number/PO#',
  i18n_cargo_classification: 'cargo classification',
  i18n_weight_kgs: 'weight(kgs)',
  i18n_weight: 'weight',
  i18n_volume_cbm: 'volume(cbm)',
  i18n_size_cm: 'size(cm)',
  i18n_sku_number: 'sku number',
  i18n_Operation: 'Operation',
  i18n_view_details: 'view details',
  i18n_view_pictures: 'view pictures',
  i18n_view_tracking: 'view tracking',
  i18n_shipping_fee_info: 'shipping fee info',
  i18n_cost_category: 'cost category',
  i18n_estimated_cost: 'estimated cost',
  i18n_actual_cost: 'actual cost',
  i18n_tracking_info: 'tracking info',
  i18n_download_labels: 'download labels',
  i18n_Contact_hotline: 'Contact hotline',
  i18n_online_chat: 'online chat',
  i18n_contact_us: 'contact us',
  i18n_mini_program: 'mini program',
  i18n_back_to_the_top: 'back to the top',
  i18n_Clients_tracking_number: 'Client\'s tracking number',
  i18n_started_date: 'started date',
  i18n_end_date: 'end date',
  i18n_Order_date: 'Order date',
  i18n_Cost: 'Cost',
  i18n_bill_status: 'bill status',
  i18n_please_choose: 'please choose ',
  i18n_pay: 'pay',
  i18n_combine_payments: 'combine payments',
  i18n_fee_details: 'fee details',
  i18n_Logistics_Product: 'Products',
  i18n_Please_choose_original_wareohuse: 'Please choose the original wareohuse location',
  i18n_please_choose_your_destination: 'please choose your destination',
  i18n_Create_new_product: 'Create new product',
  i18n_Product_name_in_Chinese: 'Product name in Chinese',
  i18n_brands: 'brands',
  i18n_HTS_code: 'HTS code',
  i18n_Material_in_Chinese: 'Material in Chinese',
  i18n_Material_in_English: 'Material in English',
  i18n_Product_uses_in_Chinese: 'Product uses in Chinese',
  i18n_electric_or_not: 'electric or not',
  i18n_yes: 'yes',
  i18n_no: 'no',
  i18n_product_name_in_English: 'product name in English',
  i18n_product_value: 'product value(USD)',
  i18n_product_value1: 'product value',
  i18n_material_in_English: 'material in English',
  i18n_Product_uses_in_English: 'Product uses in English',
  i18n_liquid_power_or_not: 'liquid/power or not',
  i18n_Create_new_address: 'Create new address',
  i18n_contact_info: 'contact info',
  i18n_contact_address: 'contact address',
  i18n_please_type_your_name: 'please type your name',
  i18n_please_type_the_contact_info: 'please type the contact info',
  i18n_please_enter_the_detailed_location: 'please enter the detailed location',
  i18n_shipper: 'shipper',
  i18n_new_shipper_address: 'new shipper address',
  i18n_receiver: 'receiver',
  i18n_pick_up_party: 'pick up party',
  i18n_delete: 'delete',
  i18n_tracking_terms_selction: 'tracking terms selction',
  i18n_full_container_load: 'full container load',
  i18n_Marine_bulk_cargo: 'Less than container',
  i18n_International_Air_Freight: 'International Air Freight',
  i18n_FBA: 'e-commerce',
  i18n_All: 'All',
  i18n_waiting_for_payment: 'waiting for payment',
  i18n_waiting_for_confirmation: 'waiting for confirmation',
  i18n_completed: 'completed',
  i18n_payment_processing: 'payment processing',
  i18n_Total_payment: 'Total payment',
  i18n_Covert_to_CNY: 'Covert to CNY',
  i18n_no_tracking_status_yet: 'no tracking status yet',
  i18n_more_tracking_status: 'more tracking status',
  i18n_click_and_download_labels: 'click and download labels',
  i18n_FBA_order: 'FBA order',
  i18n_please_enter: 'please enter ',
  i18n_PO_number: 'PO number',
  i18n_receving_warehosue: 'receving warehosue',
  i18n_shipment_arrival_time: 'shipment arrival time',
  i18n_Inquiry: 'Inquiry',
  i18n_destined_country: 'destined country',
  i18n_Cancel: 'Cancel',
  i18n_Charge_category: 'Charge category',
  i18n_Price: 'Price',
  i18n_Index_title: 'Middle East-Africa Interational Comprehensive Logistic Brand',
  i18n_Index_title: 'Cross-border Integrated Logistics Provider for Emerging Markets',
  i18n_Index_title_l: 'Middle East|Latin America|Africa|Southeast Asia',
  i18n_track_status: 'Tracking',
  i18n_Country_shipment_type: 'Country/shipment type',
  i18n_confirm_addition: 'confirm addition',
  i18n_confirm_revision: 'confirm revision',
  i18n_set_to_default: 'set to default',
  i18n_default_address: 'default address',
  i18n_set_to_default_address: 'set to default address',
  i18n_add: 'add',
  i18n_edit: 'edit',
  i18n_edit_successfully: 'edit successfully',
  i18n_added_successfully: 'added successfully',
  i18n_delete_address_tip: 'this action will delete this address，confirm to continue?',
  i18n_hint: 'hint',
  i18n_confirm: 'confirm',
  i18n_cancel: 'cancel',
  i18n_contact_person_cant_be_empty: 'contact person can\'t be empty',
  i18n_contact_number_incorrect: 'contact number is incorrect, please check and re-enter.',
  i18n_label_cannot_exceeds_5_characters: 'label size cannot exceeds 5 characters',
  i18n_new_recevier_address: 'new recevier address',
  i18n_recevier_address: 'recevier address',
  i18n_new_pickup_address: 'new pickup address',
  i18n_pickup_address: 'pickup address',
  i18n_account_login: 'account login',
  i18n_phone_number_login: 'phone number login',
  i18n_enter_account: 'please enter your account number/phone number',
  i18n_login: 'login',
  i18n_forget_password: 'forget password',
  i18n_sign_up: 'sign up',
  i18n_tick_term: 'I have been read and agree ',
  i18n_seperate: ",",
  i18n_terms_service: '"Terms of Service"',
  i18n_shipping_terms: '"Shipping Terms"',
  i18n_entrustment_agreement: '"Agreement on Export through Entrusted Trade Agent"',
  i18n_and: "and",
  i18n_citi_term: 'Cititrans User Service Terms',
  i18n_transform_term: 'Cititrans Transportation Terms and Conditions',
  i18n_Personal_Center: 'Dashboard',
  i18n_Log_out: 'Log out',
  i18n_Please_enter_your_name: 'Please enter your name',
  i18n_Please_enter_you_phone_number: 'Please enter you phone number',
  i18n_please_enter_your_password: 'please enter your password',
  i18n_please_confirm_password: 'please confirm password',
  i18n_please_enter_verification_code: 'please enter the verification code',
  i18n_I_have_been_read: 'I have been read ',
  i18n_Sign_up_Now: 'Sign up Now',
  i18n_Personal_Account: 'Personal Account',
  i18n_Name: 'Name',
  i18n_Confirm_Password: 'Confirm Password',
  i18n_Password: 'Password',
  i18n_SMS_Verification_Code: 'SMS Verification Code',
  i18n_Receive_SMS_verification_code: 'Receive SMS verification code',
  i18n_Business_Account: 'Business Account',
  i18n_Please_enter_your_business_name: 'Please enter your business name',
  i18n_Internation_User: 'Internation User',
  i18n_please_enter_your_working_email: 'please enter your working email',
  i18n_Please_enter_your_contact_number: 'Please enter your contact number',
  i18n_Please_enter_your_contact_correct_number: 'Please enter your contact correct number',
  i18n_Please_enter_your_Dubai_contact_correct_number: 'Please enter your Dubai contact correct number',
  i18n_fee_exception: 'The fee is 0, please check',
  i18n_tiHuo_fee_exception: 'The fee of TH is 0, please check',
  i18n_weight_limit: 'The weight is limited to 30KG',
  i18n_length_limit: 'The length is limited to 1.2M',
  i18n_width_limit: 'The width is limited to 1.2M',
  i18n_height_limit: 'Height limit is 1.2M',
  i18n_email_verification_code: 'email verification code',
  i18n_Please_enter_the_order_number_to_inquire: 'Please enter the order number to inquire',
  i18n_Please_enter_correct_cell_phone_number: 'Please enter the correct cell phone number',
  i18n_Please_agree_to_service_agreement_first: 'Please agree to the service agreement first!',
  i18n_Login_successful: 'Login successful',
  i18n_Please_enter_phone_number_or_verification_code: 'Please enter your cell phone number or verification code',
  i18n_Please_enter_your_email_password: 'Please enter your email or password',
  i18n_Verification_code_has_been_sent: 'Verification code has been sent',
  i18n_Please_send_again_after_second: 'Please send again after {countDown} second',
  i18n_two_entered_passwords_do_not_match: 'The two entered passwords do not match',
  i18n_phone_number_cannot_be_empty: 'The phone number cannot be empty',
  i18n_Incorrect_phone_number_format: 'Incorrect phone number format',
  i18n_Please_enter_numbers: 'Please enter numbers',
  i18n_Mailbox_cannot_be_empty: 'Mailbox cannot be empty',
  i18n_Please_enter_correct_email_format: 'Please enter the correct email format',
  i18n_Registration_successful_Please_login: 'Registration successful! Please login',
  i18n_Sure_to_exit_and_return: 'Sure to exit and return?',
  i18n_Canceled: 'Canceled',
  i18n_Quick_Login: 'quick sign in',
  i18n_magnetic_or_not: 'magnetic or not',
  i18n_Full_container_load: 'Full container load',
  i18n_entrust_information: 'entrust information',
  i18n_contact_person: 'contact person',
  i18n_entrusting_company: 'entrusting company',
  i18n_clearance_metods: 'clearance metods',
  i18n_self_clearing: 'self clearing',
  i18n_Cititran_incharges_of_double_clearing: 'Cititran incharges of double clearing',
  i18n_destination_city: 'destination city',
  i18n_contact_number: 'contact number',
  i18n_pay_party: 'pay party',
  i18n_domestic_payment: 'domestic payment',
  i18n_foreign_payment: 'foreign payment',
  i18n_warehouse_received_time: 'warehouse received time',
  i18n_origin_port: 'origin port',
  i18n_logistics_services: 'logistics services',
  i18n_receive_warehouse_number: 'receive warehouse number',
  i18n_estimated_receiving_time: 'estimated receiving time',
  i18n_location_information: 'location information',
  i18n_consignee_information: 'consignee information',
  i18n_shipper_information: 'shipper information',
  i18n_door_to_door_pickup_service: 'door-to-door pickup service',
  i18n_Collapse: 'Collapse',
  i18n_Search: 'Search',
  i18n_Close: 'Close',
  i18n_Phone: 'Phone',
  i18n_Default: 'Default',
  i18n_Detailed_address: 'Detailed address',
  i18n_Modify_Address: 'Modify Address',
  i18n_Phone_number: 'Phone number',
  i18n_no_more_than_20_characters: 'no more than 20 characters',
  i18n_product_information: 'product information',
  i18n_product_name: 'product name',
  i18n_product_name_cn: 'product name (CN)',
  i18n_product_name_en: 'product name (EN)',
  i18n_elestric: 'elestric',
  i18n_liquid_powder: 'liquid/powder',
  i18n_carton_count: 'carton count',
  i18n_single_box: 'single box',
  i18n_pcs_count: 'pcs count',
  i18n_length: 'length(cm)',
  i18n_wide: 'wide(cm)',
  i18n_height: 'height(cm)',
  i18n_length1: 'length',
  i18n_wide1: 'wide',
  i18n_height1: 'height',
  i18n_add_product: 'add product',
  i18n_product_type: 'product type',
  i18n_lwh: 'length width height(cm)',
  i18n_volume: 'volume(cbm)',
  i18n_total_weight: 'total weight(kg)',
  i18n_total_volume: 'total volume(cbm)',
  i18n_total_volume1: 'total volume',
  i18n_Total: 'Total',
  i18n_trade_information: 'trade information',
  i18n_customs_declaration_with_Agent_license: 'customs declaration with Agent’s license',
  i18n_customs_declaration_with_tax_refund: 'customs declaration with tax refund',
  i18n_remark: 'remark',
  i18n_delivery_remark: 'delivery remark',
  i18n_submit_order: 'submit order',
  i18n_upload_clearance_documents: 'upload clearance documents',
  i18n_warehouse_number: 'warehouse number',
  i18n_cannot_be_empty: 'cannot be empty',
  i18n_Success: 'Success',
  i18n_File_upload_failed: 'File upload failed',
  i18n_Upload_up_to_one_file: 'Upload up to one file',
  i18n_File_uploaded_successfully: 'File uploaded successfully',
  i18n_Please_add_products: 'Please add products',
  i18n_label: 'label',
  i18n_LTL_order: 'LTL order',
  i18n_delivery_area: 'delivery area',
  i18n_tracking: 'tracking',
  i18n_creation_time: 'creation time',
  i18n_International_Air_mail_order: 'International Air mail order',
  i18n_Pieces: 'Pieces',
  i18n_Destination: 'Destination',
  i18n_Warehouse: 'Warehouse',
  i18n_Payment_Method: 'Payment Method',
  i18n_Product_Name: 'Product Name',
  i18n_Product_Images: 'Product Images',
  i18n_No_data: 'No data',
  i18n_Fee_Name: 'Fee Name',
  i18n_Amount_receivable: 'Amount receivable',
  i18n_Amounts_payable: 'Amounts payable',
  i18n_WeChat_Pay: 'WeChat Pay',
  i18n_Alipay_payment: 'Alipay payment',
  i18n_Pay_Now: 'Pay Now',
  i18n_Payment_Remaining_Time: 'Payment Remaining Time',
  i18n_minutes: 'minutes',
  i18n_seconds: 'seconds',
  i18n_Confirmation_closure: 'Confirmation of closure?',
  i18n_select_payment_method: 'Please select the payment method first',
  i18n_Payment_success_jumping: 'Payment success, is jumping...',
  i18n_my_bills: 'my bills',
  i18n_cost_generated_time: 'cost generated time',
  i18n_invoice_number: 'invoice number',
  i18n_tracking_number: 'tracking number',
  i18n_Payment_amount: 'Payment amount',
  i18n_Payment_Time: 'Payment Time',
  i18n_No_of_picture: '0 | 1st picture | 2nd picture | 3rd picture | {count}th picture',
  i18n_Rotation: 'Rotation',
  i18n_Enlarge: 'Enlarge',
  i18n_zoom_out: 'zoom out',
  i18n_already_biggest: 'It\'s already the biggest',
  i18n_already_smallest: 'It\'s already the smallest',
  i18n_account_management: 'account management',
  i18n_change_password: 'change password',
  i18n_old_password: 'old password',
  i18n_new_password: 'new password',
  i18n_confirm_password: 'confirm password',
  i18n_confirm_edit: 'confirm edit',
  i18n_change_contact_number: 'change contact number',
  i18n_old_contact_number: 'old contact number',
  i18n_new_contact_number: 'new contact number',
  i18n_verification_code: 'verification code',
  i18n_code_or_phone_empty: 'Verification code or cell phone number cannot be empty',
  i18n_phone_error: 'The cell phone number is wrong, please fill in again',
  i18n_change_phone_success: 'Change cell phone number successfully',
  i18n_password_cannot_empty: 'The password cannot be empty!',
  i18n_Confirm_password_different: 'Confirm that the password is different!',
  i18n_sub_account_management: 'sub account management',
  i18n_account: 'account',
  i18n_usage_status: 'usage status',
  i18n_Enable: 'Enable',
  i18n_Disable: 'Disable',
  i18n_create_new_sub_account: 'create new sub account',
  i18n_User_Name: 'User Name',
  i18n_Roles: 'Roles',
  i18n_Is_main_account: 'Is the main account',
  i18n_Create_new_sub_account: 'Create a new sub-account',
  i18n_Modify_sub_account: 'Modify sub-account',
  i18n_Employee_Name: 'Employee Name',
  i18n_Email: 'Email',
  i18n_Status: 'Status',
  i18n_Confirm_continue: 'Confirm and continue',
  i18n_Confirm: 'Confirm',
  i18n_Please_enter_your_password_again: 'Please enter your password again',
  i18n_role_management: 'role management',
  i18n_create_new_role: 'create new role',
  i18n_role_name_in_chinese: 'role name in Chinese',
  i18n_role_name_in_English: 'role name in English',
  i18n_View_permissions: 'View permissions',
  i18n_Permission_assignment: 'Permission assignment',
  i18n_Modify_Role: 'Modify Role',
  i18n_Corresponding_permissions: 'Corresponding permissions',
  i18n_select_all_permissions: 'select all permissions',
  i18n_destination_country: 'destination country',
  i18n_refresh: 'refresh',
  i18n_batch_query: 'batch query',
  i18n_Business_Type: 'Business Type',
  i18n_File_Upload: 'File Upload',
  i18n_Drag_file_here_or: 'Drag the file here, or ',
  i18n_click_Upload: 'click Upload',
  i18n_xls_files_only: 'xls files only',
  i18n_Download_Template: 'Download Template',
  i18n_New_Products: 'New Products',
  i18n_Importing_Products: 'Importing Products',
  i18n_Country: 'Country',
  i18n_Uses: 'Uses',
  i18n_xls_and_xlsx_only: 'xls and xlsx files only',
  i18n_Number_of_rows: 'Number of rows',
  i18n_Is_it_successful: 'Is it successful',
  i18n_Failure: 'Failure',
  i18n_Description: 'Description',
  i18n_delete_goods_tip: 'Are you sure you want to delete this product, or do you want to continue?',
  i18n_acility_delivery_booking_management: 'acility delivery booking management',
  i18n_import_delivery_booking_document: 'import delivery booking document ',
  i18n_Box_number: 'Box number',
  i18n_Go_to_Order: 'Go to Order',
  i18n_Price_Details: 'Price Details',
  i18n_Shipping_Instructions: 'Shipping Instructions',
  i18n_Air_Freight_Information: 'Air Freight Information',
  i18n_Copy: 'Copy',
  i18n_fba_example: 'Example: FBAXXXXX',
  i18n_reference_example: 'Example：618T8E8X',
  i18n_Example_diagram: 'Example diagram',
  i18n_product_number: '{num} products',
  i18n_quantity: 'quantity',
  i18n_Select_product: 'Select product',
  i18n_New_box: 'New box',
  i18n_Kilometers: 'Kilometers',
  i18n_Previousstep: 'Previous step',
  i18n_Next_step: 'Next step',
  i18n_name_or_phone_number: 'Please enter your name or phone number',
  i18n_Product_List: 'Product List',
  i18n_Product_Type: 'Product Type',
  i18n_Error_Description: 'Error Description',
  i18n_Length_of_characters: 'Length can only be {num} characters',
  i18n_Numbers_letters_only: 'Numbers and letters only',
  i18n_Must_start_with_FBA: 'Must start with FBA',
  i18n_more_than0_two_decimal: 'Greater than zero and retaining up to two decimal places',
  i18n_Product_Templates: 'Product Templates',
  i18n_Deleted_successfully: 'Deleted successfully',
  i18n_Products: 'Products',
  i18n_Only_same_type: 'Only the same type of goods can be placed in a single box',
  i18n_No_more_3_in_one_box: 'No more than 3 items in a single box',
  i18n_add_product_in_box: 'Please add the product information in box {no}',
  i18n_duplicate_box_numbers: 'Please check for duplicate box numbers',
  i18n_number_of_products_cannot_0: 'The number of products added cannot be 0',
  i18n_Already_default_address: 'Already the default address',
  i18n_Please_fill_box_information: 'Please fill in the complete box information',
  i18n_Sure_delete: 'Sure to delete?',
  i18n_status_is_edit_close: 'The current status is edit, do you want to close it?',
  i18n_fill_correct_price: 'Please fill in the correct price',
  i18n_Shipper_Information: 'Shipper Information',
  i18n_Add_consignor: 'Add consignor',
  i18n_No_default_contact: 'No default contact please add',
  i18n_No_contact: 'No contact please add',
  i18n_Order_Information: 'Order Information',
  i18n_Total_weight: 'Total weight',
  i18n_Total_pieces: 'Total pieces',
  i18n_Total_boxes: 'Total boxes',
  i18n_Boxes: 'Boxes',
  i18n_Carriage_goods_agreement: 'Carriage of goods agreement',
  i18n_select_or_add_shipper: 'Please select or add shipper information',
  i18n_complete_receive_information: 'Please complete the receive information',
  i18n_complete_sender_information: 'Please complete the sender information',
  i18n_agree_agreement_first: 'Please agree to the agreement first',
  i18n_Failed_to_get: 'Failed to get',
  i18n_Box_Details: 'Box Details',
  i18n_product_quantity: 'Product Quantity',
  i18n_Are_your_confirm_order: 'Are your confirm to order?',
  i18n_confirmed_enter_warehouse: 'Have you confirmed the order to enter the warehouse?',
  i18n_confirm_order: 'confirm order',
  i18n_order_completed: 'order completed',
  i18n_waiting_shipment_to_warehoused: 'waiting shipment to be warehoused',
  i18n_consignee_address: 'consignee address',
  i18n_track_order: 'track order',
  i18n_continue_to_order: 'continue to order',
  i18n_more_contact_information: 'more contact information',
  i18n_pickup_location: 'pickup location',
  i18n_address_book: 'address book',
  i18n_pickup_person: 'pickup person',
  i18n_pickup_contact_number: 'pickup contact number',
  i18n_pickup_time: 'pickup time',
  i18n_send_goods_to_following_address: 'Please send the goods to the following address',
  i18n_Warehouse_Address: 'Warehouse Address',
  i18n_cost_calculation: 'cost calculation',
  i18n_shipping_cost: 'shipping cost',
  i18n_global_delivery_cost: 'global delivery cost',
  i18n_pickup_fee: 'pickup fee',
  i18n_ocean_freight_cost: 'ocean freight cost',
  i18n_pickup_at_original_port: 'door-to-door pickup at original port',
  i18n_total_cost: 'total cost',
  i18n_subtotal: 'subtotal',
  i18n_shipment_information: 'shipment information',
  i18n_shipment_instruction: 'shipment instruction',
  i18n_warehosue_received_date: 'warehosue received date',
  i18n_custom_clearance_method: 'custom clearance method',
  i18n_customs_declaration: 'customs declaration with Agent’s license',
  i18n_Tax_refund: 'Tax refund',
  i18n_no_receiving_information: 'no receiving information yet',
  i18n_pickup_cargo_at_below_warehouse: 'Please pickup the cargo at below destination warehouse',
  i18n_forecast_weight_kgs: 'forecast weight(kgs)',
  i18n_forecast_volume_cbm: 'forecast volume(cbm)',
  i18n_forecast_quantity: 'forecast quantity',
  i18n_actual_weight_kgs: 'actual weight(kgs)',
  i18n_actual_volume_cbm: 'actual volume(cbm)',
  i18n_actual_quantity: 'actual quantity',
  i18n_package_details: 'package details',
  i18n_invoices_generated_time: 'invoices generated time',
  i18n_invoice_status: 'invoice status',
  i18n_cancelled: 'cancelled',
  i18n_Offline: 'Offline',
  i18n_check_payment_receipt: 'check payment receipt',
  i18n_upload_payment_receipt: 'upload payment receipt',
  i18n_payment_information: 'payment information',
  i18n_ocean_freight_information: 'ocean freight information',
  i18n_land_transportation_information: 'land transportation information',
  i18n_Value_added_service: 'Value-added service',
  i18n_shipping_information: 'shipping information',
  i18n_Shop_number: 'Shop number',
  i18n_provide_accurate_quantity_value: 'please provide the accurate product quantity and value',
  i18n_more_consignee_information: 'more consignee information',
  i18n_FBA_facility_warehosue_information: 'FBA facility warehosue information',
  i18n_pickup_remark: 'pickup remark',
  i18n_Billing_Number: 'Billing Number',
  i18n_Go_to_pay: 'Go to pay',
  i18n_Abandoned: 'Abandoned',
  i18n_Image_Upload: 'Image Upload',
  i18n_Confirm_Upload: 'Confirm Upload',
  i18n_Up_to_6_JPG: 'Up to 6 uploads, JPG/JPEG/PNG format only',
  i18n_Upload_successful: 'Upload successful',
  i18n_Exceeding_quantity_limit: 'Exceeding the quantity limit',
  i18n_void_bill_continue: 'This action will void the bill, should I continue?',
  i18n_discarded_in_financial_verification_payment_receipt: 'Is the offline payment successful and discarded in the financial verification payment receipt?',
  i18n_no_quotation_contact_salesman: 'There is no quotation for this line, please contact the salesman',
  i18n_no_track: 'There is no track information, please re-enter the order number to check',
  i18n_natural_days: ' natural days',
  i18n_Inquiry_receipt: 'Inquiry receipt',
  i18n_Confirmation_selection: 'Confirmation of selection',
  i18n_Importing_boxes: 'Importing boxes',
  i18n_Click_line_select_address: 'Click on any line to select your address',
  i18n_product_value_bigger_0: 'The value of the goods must be greater than 0',
  i18n_Warehouse_Code: 'Warehouse Code',
  i18n_More_consignor_information: 'More consignor information',
  i18n_Slogan: 'Digital Logistics Connects the World',
  i18n_confirm_delete_address: 'Are you sure you want to delete the contact?',
  i18n_Please_choose_pick_up_time: 'Please choose a pick-up time',
  i18n_Please_select_pick_up_address: 'Please select a pick-up address',
  i18n_Pickup_Information: 'Pickup Information',
  i18n_Value_Added_Service_Fee: 'Value Added Service Fee',
  i18n_Order_Status: 'Order Status',
  i18n_Pickup_Status: 'Pickup Status',
  i18n_warehouse_status: 'warehouse status',
  i18n_Booking_Status: 'Booking Status',
  i18n_China_Hong_Kong_Status: 'China-Hong Kong Status',
  i18n_Trunk_status: 'Trunk status',
  i18n_Customs_clearance_status: 'Customs clearance status',
  i18n_Distribution_Center_Status: 'Distribution Center Status',
  i18n_delivery_status: 'Delivery status',
  i18n_LCL_status: 'LCL status',
  i18n_Cabinet_status: 'Cabinet status',
  i18n_from_x_currency: 'From {price} {currency}',
  i18n_not_logged_in_login_first: 'You are not logged in, please login first',
  i18n_hotline_number: 'hotline number',
  i18n_cititrans: 'Cititrans (Shenzhen) International Logistics Co., Ltd.',
  i18n_customer_service: 'customer service',
  i18n_fax: 'fax',
  i18n_WeChat_ID: 'WeChat ID',
  i18n_Online_WeChat_Customer_service: 'Online WeChat Customer service',
  i18n_scan_qr_code_for_service: 'please scan the QR code to add our customer representative',
  i18n_Address: 'Address',
  i18n_cititrans_address: 'Room 810, Block A, Building 12, Shenzhen Bay Science and Technology Ecological Park, No. 18, Keji South Road, Nanshan District, Shenzhen',
  i18n_pecies_quantity_greater_than_0: 'pecies quantity has to greater than 0',
  i18n_cant_exceed_250_to_0_cm: 'can\'t exceed 250 CM or less than 0 cm',
  i18n_Reservation_delivery_warehouse: 'Reservation for delivery to warehouse',
  i18n_Schedule_warehouse_delivery_start_time: 'Schedule warehouse delivery start time',
  i18n_Schedule_warehouse_delivery_end_time: 'Schedule warehouse delivery end time',
  i18n_Reservation_warehouse_delivery_number: 'Reservation of warehouse delivery number',
  i18n_Reservation_warehouse_template: 'Reservation warehouse template',
  i18n_warehouse_receipt: 'warehouse receipt',
  i18n_no_sevice_add: 'No value-added services for this line',
  i18n_no_service_add_continue: 'There is no value-added service for this line, please click the next step to continue',
  i18n_More: 'More',
  i18n_Entrusted: 'Entrusted',
  i18n_Booking_status: 'Booking status',
  i18n_Shipping_Schedule_Status: 'Shipping Schedule Status',
  i18n_box_no_image: 'Box {index} Please upload the product picture.',
  i18n_Image_upload: 'Image upload',
  i18n_Preview: 'Preview',
  i18n_By_detail: 'By detail',
  i18n_By_summary: 'By summary',
  i18n_Reference: 'Reference',
  i18n_Estimate_inWarehouse_cost: 'Estimated cost of warehousing',
  actual_fee_after_loading: 'The specific cost is subject to the actual loading',
  i18n_Image_manage: 'Image manage',
  i18n_Image_manage1: 'All boxes can only select one type of goods',
  i18n_non_electrified_flight: 'Non charged/non-magnetic/single product name',
  i18n_domestic_flights: 'Domestic flights',
  i18n_minimum_20kg: 'Minimum consumption per ticket is 20KG',
  i18n_minimum_150kg: 'Minimum consumption per ticket is 150KG',
  i18n_warehosue_information: 'Warehosue information',
  i18n_warehouse_dongguan: 'Dongguan Warehouse',
  i18n_warehouse_foshan: 'Foshan Warehouse',
  i18n_warehouse_yiwu: 'Yiwu Warehouse',
  i18n_warehouse_air_sea: 'Air/Ocean',
  i18n_warehouse_sea: 'Ocean',
  i18n_warehouse_dongguan_address: 'Cititrans Logistics, 1st Floor, Industrial Park, No. 6 Shiqiao Road, Jiaoyitang, Tangxia Town, Dongguan City, Guangdong Province',
  i18n_warehouse_foshan_address: 'Cititrans International Warehouse, Room 103, Building A, Daguangjia (Wenjiao Warehouse), No. 51 Wenjiao Road, Wenjiao Community, Lishui Town, Nanhai District, Foshan City',
  i18n_warehouse_yiwu_address: 'Gate 14, 2nd Floor, Building 2, JD Asia No. 1 Electronics Industrial Park, No. 1000 Siji Road, Beiyuan Subdistrict, Yiwu City',
  i18n_warehouse_dongguan_contact: 'Contact: 18925240918',
  i18n_warehouse_foshan_contact: 'Zhou Yangjun: 18102806630/13126479218',
  i18n_warehouse_yiwu_contact: 'Fang Famin: 1569213657'
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/lang/en.js